import createWebStorage from 'redux-persist/lib/storage/createWebStorage';
import storageRedux from 'redux-persist/lib/storage';

const storage = typeof window === 'undefined' ? storageRedux : createWebStorage('local');

export default storage;
